<!--
 * @Author:
 * @Description: 规则设置
-->
<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <div class="relative">
      <div
        class="border-l-3 border-color-primary flex-1 pl-10px text-16px mt-10px mb-20px font-bold"
      >
        基本信息
      </div>
      <div class="absolute top-[-12px] right-0">
        <el-button type="primary" @click="toSave">保存</el-button>
        <el-button type="default" @click="toCancel">返回</el-button>
      </div>
      <el-form label-width="130px" ref="basicForm" label-position="right">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item class="w-full" label="数据标准库：">
              <el-select
                v-model="standardId"
                class="w-full"
                size="small"
                placeholder="请选择标准库"
                @change="changeStandardId"
                filterable
                disabled
              >
                <el-option
                  v-for="item in standardList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="w-full" label="规则类型：">
              <el-select
                v-model="regType"
                class="w-full"
                size="small"
                placeholder="请选择规则类型"
                @change="changeRegType"
                filterable
                clearable
              >
                <el-option
                  v-for="item in ruleTypeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h-[calc(100%-150px)] relative">
      <div class="absolute top-[-12px] right-0">
        <el-button type="primary" @click="addData">添加</el-button>
        <el-button type="danger" @click="delData">删除</el-button>
      </div>
      <div
        class="border-l-3 border-color-primary flex-1 pl-10px text-16px mt-10px mb-20px font-bold"
      >
        规则设置
      </div>
      <div class="w-full h-full">
        <!-- 正则表达式 -->
        <el-table
          v-if="regType === 1"
          height="100%"
          :data="tableData"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          border
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column label="类别代码" prop="classId" width="340px">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.classId"
                placeholder="类别代码"
                class="w-300px mr-10px"
                size="small"
                @change="classSelectChange($event, scope.row)"
                collapse-tags
                filterable
                clearable
              >
                <el-option
                  v-for="item in classList"
                  :key="item.id"
                  :label="`${item.code}_${item.name}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="类别名称" prop="className" width="150px" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.className }}</span>
            </template>
          </el-table-column>
          <el-table-column label="同步应用子类" width="150px">
            <template slot-scope="scope">
              <el-select v-model="scope.row.syncSubclass">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="规则名称" width="300px">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ruleName" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="校验规则表达式">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ruleExpression" clearable></el-input>
            </template>
          </el-table-column>
        </el-table>
        <!-- 符号分割 -->
        <ul v-else class="w-full text-14px overflow-y-auto">
          <li
            class="border-1px border-color-base-border p-10px mb-10px h-100px"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div class="float-left pt-22px">
              <span class="mr-10px">
                <el-checkbox
                  v-model="item.check"
                  @change="handleSelectionChange(item)"
                ></el-checkbox>
              </span>
              <span class="mr-10px">
                类别代码：
                <el-select class="w-200px" v-model="item.classId" filterable clearable>
                  <el-option
                    v-for="item in classList"
                    :key="item.id"
                    :label="`${item.code}_${item.name}`"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </span>
              <span class="mr-10px">
                分隔符：
                <el-input class="w-60px" v-model="item.splitChar"></el-input>
              </span>
              <span class="mr-10px">
                分段数：
                <el-input-number
                  class="w-60px"
                  v-model="item.sectionNumber"
                  :min="1"
                  :max="10"
                  :controls="false"
                  @change="handleSegmentNumChange($event, item)"
                ></el-input-number>
              </span>
            </div>
            <div v-for="index in item.sectionNumber" :key="index" class="inline-block mr-10px">
              <div class="mb-5px">
                <el-select
                  class="w-100px"
                  v-model="item.sectionRule[index - 1].type"
                  placeholder="请选择分段类型"
                  filterable
                  @change="handleSectionTypeChange($event, item, index - 1)"
                >
                  <el-option
                    v-for="val in segmentTypeList"
                    :key="val.type"
                    :label="val.name"
                    :value="val.type"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <el-input
                  v-if="item.sectionRule[index - 1].type === 0"
                  class="w-100px"
                  v-model="item.sectionRule[index - 1].value"
                  placeholder="请输入"
                ></el-input>
                <el-select
                  v-else-if="item.sectionRule[index - 1].type === 1"
                  class="w-100px"
                  v-model="item.sectionRule[index - 1].value"
                  filterable
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="ref in referenceData"
                    :key="ref.id"
                    :label="ref.name"
                    :value="ref.id"
                  ></el-option>
                </el-select>
                <el-input
                  v-else-if="item.sectionRule[index - 1].type === 2"
                  class="w-100px"
                  v-model="item.sectionRule[index - 1].value"
                  placeholder="请输入"
                ></el-input>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </el-card>
</template>

<script>
import standardManagementService from '@/services/common/StandardManagementService'
import stdClassListService from '@/services/stdClassListService'
import referenceDataService from '@/services/ReferenceDataService'
import dataValidationReportService from '@/services/dataValidationReportService'

export default {
  name: 'ruleSettings',
  data() {
    return {
      regType: 1, // 1正则表达式,2符号分割
      standardId: localStorage.getItem('standardId'),
      tableData: [],
      classList: [],
      standardList: [],
      ruleTypeList: [
        { id: 1, name: '正则表达式' },
        { id: 2, name: '符号分割' },
      ],
      tableSelectionsIndexs: [],
      selections: [],
      segmentTypeList: [
        // { type: 1, name: '字符串' },
        // { type: 2, name: '参考数据' },
        // { type: 3, name: '正则表达式' },
      ],
      referenceData: [], // 参考数据列表
    }
  },
  computed: {
    pageType() {
      return this.$route.query.type
    },
  },
  async created() {
    await this.getStandardList()
    await this.getDetail()
    this.getTypeList()
  },
  methods: {
    // 获取标准库
    async getStandardList() {
      const res = await standardManagementService.getList()
      if (res && res.data && res.code === 0) {
        this.standardList = res.data
      }
    },
    // 标准库选择
    changeStandardId(val) {
      this.standardId = val
      this.getTypeList()
      this.getDetail()
    },
    // 规则类型选择
    changeRegType() {
      this.tableData = []
      this.getDetail()
      if (this.regType === 2) {
        // 符号分割
        this.getSegmentTypeList()
        this.getReferenceData()
      }
    },
    // 表格多选
    handleSelectionChange(val) {
      if (this.regType === 1) {
        this.tableSelectionsIndexs = val.map((item) => {
          return this.tableData.indexOf(item)
        })
        this.selections = val
      } else {
        this.tableSelectionsIndexs = this.tableData.reduce((acc, item, index) => {
          if (item.check) acc.push(index)
          return acc
        }, [])
        this.selections = this.tableData.filter((item) => {
          return item.check
        })
      }
    },
    // 添加
    addData() {
      if (!this.standardId) {
        this.$message.warning('请选择标准库')
        return
      }
      if (this.regType === 1) {
        // 正则表达式
        this.tableData.push({
          classId: '',
          className: '',
          syncSubclass: 1,
          ruleName: '',
          ruleExpression: '',
        })
      } else {
        // 符号分割
        this.tableData.push({
          classId: '',
          sectionNumber: 1,
          sectionRule: [
            {
              index: 0,
              type: 0, // 默认选中字符串类型
              value: '',
            },
          ],
        })
      }
    },
    // 保存
    async toSave() {
      console.log(this.tableData)
      if (!this.validateTableData()) return

      const params = []
      this.tableData.forEach((item) => {
        params.push({
          standardId: this.standardId,
          ruleType: this.pageType === 'document' ? 1 : 0,
          ...item,
        })
      })
      let res = null
      if (this.regType === 1) {
        // 正则表达式
        res = await dataValidationReportService.validationRuleSave(params)
      } else {
        // 符号分割
        res = await dataValidationReportService.charSplitRuleSave(params)
      }
      if (res && res.code === 0) {
        this.$message.success('保存成功')
      }
    },
    // 获取详情
    async getDetail() {
      const params = {
        standardId: this.standardId,
        ruleType: this.pageType === 'document' ? 1 : 0,
      }
      let res = null
      if (this.regType === 1) {
        // 正则表达式
        res = await dataValidationReportService.getValidationRuleDetail(params)
      } else {
        // 符号分割
        res = await dataValidationReportService.getCharSplitRuleDetail(params)
      }
      if (res && res.code === 0) {
        this.tableData = res.data || []
      }
    },
    // 校验表格数据
    validateTableData() {
      if (!this.tableData.length) {
        this.$message.warning('请添加数据')
        return false
      }

      for (let i = 0; i < this.tableData.length; i += 1) {
        const item = this.tableData[i]
        if (this.regType === 1) {
          // 正则表达式
          if (!item.classId) {
            this.$message.warning(`第${i + 1}行类别代码未填写`)
            return false
          }
          if (!item.ruleName) {
            this.$message.warning(`第${i + 1}行规则名称未填写`)
            return false
          }
          if (!item.ruleExpression) {
            this.$message.warning(`第${i + 1}行校验规则表达式未填写`)
            return false
          }
        } else {
          // 符号分割
          if (!item.classId) {
            this.$message.warning(`第${i + 1}行类别代码未填写`)
            return false
          }
          if (!item.sectionRule || !item.sectionRule.length) {
            this.$message.warning(`第${i + 1}行分段信息未填写`)
            return false
          }
          for (let j = 0; j < item.sectionRule.length; j += 1) {
            const segment = item.sectionRule[j]
            if (!segment.value) {
              this.$message.warning(`第${i + 1}行第${j + 1}段内容未填写`)
              return false
            }
          }
        }
      }
      return true
    },
    // 取消
    toCancel() {
      this.$router.go(-1)
    },
    // 删除表格数据
    delData() {
      if (!this.tableSelectionsIndexs.length) {
        this.$message.warning('请勾选数据')
        return
      }
      this.$confirm('确认删除所选数据？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = [...this.tableData]
        // 本地删除
        this.tableData = data.filter((_, index) => {
          return !this.tableSelectionsIndexs.includes(index)
        })

        // 接口删除
        const ids = []
        this.selections.forEach((item) => {
          if (item.id) ids.push(item.id)
        })
        if (ids.length) {
          let res = null
          if (this.regType === 1) {
            res = await dataValidationReportService.validationRuleDelete(ids)
          } else {
            res = await dataValidationReportService.charSplitRuleDelete(ids)
          }
          if (res && res.code === 0) {
            this.$message.success('删除成功')
          }
        } else {
          this.$message.success('删除成功')
        }
      })
    },
    // 处理分段数变化
    handleSegmentNumChange(value, item) {
      if (!item.sectionRule) {
        item.sectionRule = []
      }

      // 如果新的分段数大于现有分段数，添加新的分段
      while (item.sectionRule.length < value) {
        item.sectionRule.push({
          index: item.sectionRule.length,
          type: 0, // 默认选中字符串类型
          value: '',
        })
      }

      // 如果新的分段数小于现有分段数，删除多余的分段
      if (item.sectionRule.length > value) {
        item.sectionRule = item.sectionRule.slice(0, value)
      }
    },
    // 类别选择
    classSelectChange(e, row) {
      const data = this.classList.find((item) => {
        return item.id === e
      })
      row.className = data.name
    },
    // 文档获取类别下拉数据
    async getTypeList() {
      if (!this.standardId) return
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1,
        info_type: this.pageType === 'document' ? 1 : 0, // 1文档,0位号
        catecode: this.pageType === 'document' ? 'Document' : 'Tag', // 文档
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0) {
        this.classList = res.data
      }
    },
    // 获取分段规则类型
    async getSegmentTypeList() {
      const res = await dataValidationReportService.charSplitGetSectionRule()
      if (res && res.code === 0) {
        this.segmentTypeList = res.data
      }
    },
    // 获取参考数据
    async getReferenceData() {
      const res = await referenceDataService.getCategory({
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        this.referenceData = res.data.map((item) => {
          return {
            id: item.id,
            name: item.name,
          }
        })
      }
    },
    // 分段类型改变
    handleSectionTypeChange(value, item, index) {
      item.sectionRule[index].value = ''
    },
  },
}
</script>

<style lang="scss" scoped>

.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
  font-weight: normal;
}
.tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-blue {
  color: #409eff;
}

</style>
